import React from 'react'
import PropTypes from 'prop-types'
import { MenuItem, SelectField } from 'material-ui'
import { TableRow, TableRowColumn } from 'material-ui/Table'
import RadioButton from './RadioButton'

export default function ApptTypesTableRow({
  appointmentType,
  appointmentType: {
    code,
    description,
    post_nv_window: postNvWindow,
    visibility,
  },
  hasPatientPortal,
  preventDefaultUpdate,
}) {
  const apptTypeVisbilities = ['new', 'existing']
  const centerStyle = { padding: 0, textAlign: 'center' }

  return (
    <TableRow>
      <TableRowColumn style={centerStyle}>
        <span>{code}</span>
        <br />
        <span>{description}</span>
      </TableRowColumn>
      {apptTypeVisbilities.map(apptVisibility => (
        <TableRowColumn key={code} style={centerStyle}>
          <RadioButton
            updatedAppointmentVisibility={apptVisibility}
            appointmentType={appointmentType}
            preventDefaultUpdate={preventDefaultUpdate}
          />
        </TableRowColumn>
      ))}
      {hasPatientPortal && <TableRowColumn style={centerStyle}>
        {visibility === 'existing' &&
          <SelectField
            id="postNvWindow"
            autoWidth
            onChange={
              (e, ind, val) => preventDefaultUpdate(visibility, appointmentType, val)
            }
            value={postNvWindow}
            style={{ width: '75%' }}
          >
            <MenuItem value={1} primaryText="1 Week" />
            <MenuItem value={2} primaryText="2 Weeks" />
            <MenuItem value={3} primaryText="3 Weeks" />
            <MenuItem value={4} primaryText="4 Weeks" />
            <MenuItem value={104} primaryText="No Limit" />
          </SelectField>
        }
      </TableRowColumn>}
    </TableRow>
  )
}

ApptTypesTableRow.propTypes = {
  appointmentType: PropTypes.shape({
    code: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }),
  preventDefaultUpdate: PropTypes.func.isRequired,
  hasPatientPortal: PropTypes.bool.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/AppointmentTypes/ApptTypesTableRow.js